// Marks that the page is about to reload because the user clicked the
// new-version banner's Refresh (see NewVersionAvailableBanner).
// UnsavedChangesDialog checks this to skip the native "leave site?" prompt for
// that reload: the banner already asked the user to save first, and the
// server-side draft autosave (AB#6079) preserves the work. The automatic
// chunk-error reload does not mark itself and keeps the prompt (AB#6757).
// Module-scoped is enough: beforeunload fires synchronously in the same
// document context before the reload.
let recoveryReloadInProgress = false

export const markRecoveryReload = (): void => {
  recoveryReloadInProgress = true
  // If the reload completes, this page context is gone and the timer never
  // fires. If something prevents the reload, restore the guard so the
  // unsaved-changes protection isn't left disabled for the rest of the
  // session.
  setTimeout(() => {
    recoveryReloadInProgress = false
  }, 5_000)
}

export const isRecoveryReloadInProgress = (): boolean => recoveryReloadInProgress
